/**
 * IMPORTS
 */

const LoadingFinalizeExpedition = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Label Mensagem */}
      <div className="space-y-2">
        <div className="h-5 w-32 animate-pulse rounded bg-zinc-200" />
        <div className="h-24 w-full animate-pulse rounded bg-zinc-200" />
      </div>

      {/* Forma de Entrega */}
      <div className="space-y-3">
        <div className="h-5 w-40 animate-pulse rounded bg-zinc-200" />
        <div className="flex flex-col gap-3">
          <div className="h-5 w-28 animate-pulse rounded bg-zinc-200" />
          <div className="h-5 w-36 animate-pulse rounded bg-zinc-200" />
          <div className="h-5 w-40 animate-pulse rounded bg-zinc-200" />
        </div>
      </div>

      {/* Botão */}
      <div className="h-10 w-full animate-pulse rounded bg-zinc-200" />
    </div>
  );
};

/**
 * EXPORTS
 */
export { LoadingFinalizeExpedition };
